import React from 'react';
import { Navbar } from '../components/Navbar';
import { StickyFooter } from '../components/StickyFooter';
import { ServiceHero } from '../components/ServiceHero';
import { ServiceContactForm } from '../components/ServiceContactForm';
import { CheckCircleIcon } from 'lucide-react';
export function TemporaryHealthcareAides() {
  return <div className="min-h-screen w-full bg-white flex flex-col" data-id="element-1105">
      <Navbar data-id="element-1106" />
      <main className="flex-1" data-id="element-1107">
        <ServiceHero badge="Services" title="Temporary Healthcare Aides" subtitle="Reliable, vetted temporary healthcare aides ready to support your facility's staffing needs on short notice." imageUrl="https://images.unsplash.com/photo-1576091160550-2173dba999ef?w=1600&auto=format&fit=crop" data-id="element-1108" />

        <div className="max-w-4xl mx-auto px-4 py-16 lg:py-24" data-id="element-1109">
          <div className="prose prose-lg max-w-none text-text-muted leading-relaxed space-y-6" data-id="element-1110">
            <p data-id="element-1111">
              Our Temporary Healthcare Aides (THA) provide essential support to
              nursing staff and patients in various healthcare settings. They
              are trained to assist with daily living activities, ensuring
              patients receive compassionate and competent care.
            </p>
            <p data-id="element-1112">
              Whether you need coverage for a single shift, a short-term leave,
              or ongoing support during peak periods, our platform connects you
              with qualified THAs in minutes. Every aide on our platform has
              undergone rigorous background checks and clinical vetting by our
              Registered Nurse leadership team.
            </p>
          </div>

          <div className="mt-12 bg-gray-50 rounded-2xl p-8 border border-gray-100" data-id="element-1113">
            <h3 className="text-2xl font-bold text-text-dark mb-6" data-id="element-1114">
              Why Choose Our Healthcare Aides?
            </h3>
            <ul className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-1115">
              {['Rigorous background checks & credential verification', 'Trained in daily living assistance & patient mobility', 'Available for short-notice & emergency shifts', 'Clinically vetted by our RN leadership team', 'Compassionate, patient-first approach', 'Seamless integration with your existing staff'].map((feature, i) => <li key={i} className="flex items-start gap-3" data-id="element-1116">
                  <CheckCircleIcon className="w-6 h-6 text-accent-teal flex-shrink-0 mt-0.5" data-id="element-1117" />
                  <span className="text-text-dark font-medium" data-id="element-1118">{feature}</span>
                </li>)}
            </ul>
          </div>
        </div>

        <ServiceContactForm serviceName="Temporary Healthcare Aides" data-id="element-1119" />
      </main>
      <StickyFooter data-id="element-1120" />
    </div>;
}